import FeatureFlagWrapperComponent from './components/FeatureFlagWrapper'
import utils from './utils'

export const shouldShowFeature = utils.shouldShowFeature
export const isUserFlagEnabled = utils.isUserFlagEnabled
export const userFlagsEnabled = utils.userFlagsEnabled

export const FeatureFlagWrapper = FeatureFlagWrapperComponent
